module.exports = "/next-static/_next/static/images/testimonial_2_author-f632765cc48917c6fcbab1ce619cb2ad.png";